import { Directive, ElementRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[layoutRow]'
})
export class LayoutRowDirective {
    public static cls = 'layout-row';

    constructor(private elementRef: ElementRef) {
        (elementRef.nativeElement as HTMLElement).classList.add(LayoutRowDirective.cls);
    }

}
